angular.module('cfn').directive('cfnPageButtons', function() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: { requiredWidth: '@' },
    templateUrl: require('./cfnPageButtons.html')
  };
});

angular.module('cfn').directive('cfnDetailsButtons', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      transclude: true,
      replace: true,
      template:
        '<div ng-transclude class="detailsButtons" ng-style="{width:window.contentRightWidth+\'px\'}"></div>',
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);
